module.exports = __webpack_public_path__ + "static/media/game_board.bf9ecfee.jpg";